export class Customerlogo {
    customerId:string;
    date_added:Date;
    customerlogo?:string;
    customerlogourl?:any;
}